import React, { useState, useEffect } from 'react';
import './App.css';
import LandingPage from './components/LandingPage';
import LoginForm from './components/LoginForm';
import DeletionChecklist from './components/DeletionChecklist';
import FinalConfirmation from './components/FinalConfirmation';
import ConfirmationPage from './components/ConfirmationPage';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './firebase/config';

type Step = 'landing' | 'login' | 'checklist' | 'confirm' | 'success';

function App() {
  const [currentStep, setCurrentStep] = useState<Step>('landing');
  const [userEmail, setUserEmail] = useState<string>('');
  const [referenceNumber, setReferenceNumber] = useState<string>('');

  const handleStepChange = (newStep: Step) => {
    setCurrentStep(newStep);
  };

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      if (user && user.email) {
        setUserEmail(user.email);
      }
    });
    return unsubscribe;
  }, []);

  const handleLoginSuccess = () => {
    handleStepChange('checklist');
  };

  const handleDeletionConfirmed = (requestId: string) => {
    setReferenceNumber(requestId);
    handleStepChange('success');
  };

  return (
    <div className="App">
      <div className="container">
        {currentStep === 'landing' && <LandingPage onContinue={() => handleStepChange('login')} />}
        {currentStep === 'login' && <LoginForm onLoginSuccess={handleLoginSuccess} />}
        {currentStep === 'checklist' && (
          <DeletionChecklist
            onContinue={() => handleStepChange('confirm')}
            onCancel={() => handleStepChange('landing')}
          />
        )}
        {currentStep === 'confirm' && (
          <FinalConfirmation
            onConfirm={handleDeletionConfirmed}
            onCancel={() => handleStepChange('checklist')}
          />
        )}
        {currentStep === 'success' && (
          <ConfirmationPage referenceNumber={referenceNumber} email={userEmail} />
        )}
      </div>
    </div>
  );
}

export default App;
